import { APIService } from "./APIService"
import { TransactionType } from "./types"

const getStatus = (offerId: string, transactionId: string) =>
  APIService.get<null, TransactionType>(
    `/profiles/:profileId/offers/${offerId}/transactions/${transactionId}`,
  )

const repaid = (offerId: string, transactionId: string) =>
  APIService.post<null, TransactionType>(
    `/profiles/:profileId/offers/${offerId}/transactions/${transactionId}/repaid`,
  )

export const ProfileTransactionService = {
  getStatus,
  repaid,
}
